module.exports = __webpack_public_path__ + "img/HYPRMobileApp_Hero.5fd9f9c0.jpg";